import { NOTIFICATION_RECEIVED } from "../constants/types/dashboardType";

const initialState = {
  notification: {},
};

export const dashboardReducer = (state = initialState, action) => {
  switch (action.type) {
    case NOTIFICATION_RECEIVED:
      return {
        ...state,
        notification: action.payload.notification,
      };

    default:
      return state;
  }
};
